import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";

import { formatUpperCase } from "../../../../utils/formats";

const LojistaShortSection = (props) => {
  const {
    proposalCompleteRegistrationLoading,
    nomeAgente,
    ratingFilial,
    ufFilial,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Agente"
            value={nomeAgente}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Rating (loja)"
            value={formatUpperCase(ratingFilial)}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="UF (loja)"
            value={formatUpperCase(ufFilial)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default LojistaShortSection;
